// Webpack Imports
import 'jquery';
import * as bootstrap from 'bootstrap';
// import 'slick-carousel';
import 'magnific-popup';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

  $(function() {
    const initPageProperySlider = function() {
      if ($(window).width() >= 768) {
        // $(".page-template-single-property .slick").slick({
        //   infinite: true,
        //   slidesToShow: 2,
        //   slidesToScroll: 2,
        //   arrows: false,
        //   vertical: true,
        //   verticalSwiping: true,
        //   variableHeight: true,
        // });
  
        // function setSlideHeight(that) {
        //   $('.swiper-slide').css({height:'auto'});
        //   var currentSlide = that.activeIndex;
        //   var newHeight = $(that.slides[currentSlide]).height() + $(that.slides[currentSlide + 1]).height() + 20;
  
        //   $('.swiper-wrapper').css({ height : newHeight })
        //   that.update();
        // }
  
        // const swiper = new Swiper('.page-template-single-property .swiper', {
        //   direction: 'vertical',
        //   loop: true,
        //   slidesPerView: 2,
        //   spaceBetween: 20,
        //   on: {
        //     init: function() {
        //       setSlideHeight(this);
        //     },
        //     slideChangeTransitionEnd: function() {
        //       setSlideHeight(this);
        //     }
        //   }
        // })
  
        // const itemsSize = $('.img-gallery .item').map(function () {
        //   const top = $(this).offset().top
        //   return {
        //     start: top,
        //     end: top + $(this).outerHeight(),
        //   }
        // }).toArray()
  
        // var lastItemIndex = -1;
    
        // const onScroll = function() {
        //   var scrollTop = $('.img-gallery').scrollTop()
        //   var currentItemIndex = 0
    
        //   for (const [index, item] of itemsSize.entries()) {
        //     if (scrollTop > item.start && scrollTop <= item.end) {
        //       currentItemIndex = index
        //       break
        //     }
        //   }
    
        //   if (lastItemIndex != currentItemIndex) {
        //     lastItemIndex = currentItemIndex
  
        //     console.log('index', currentItemIndex)
        //   }
        // }
  
        // $('.img-gallery').on('scroll',onScroll);
        // onScroll()
      }
    }
  
    const initLightbox = function() {
      $('.img-gallery').magnificPopup({
        delegate: '.item:not(.slick-cloned)',
        type: 'image',
        gallery: {
          enabled: true
        },
      });
    }
  
    const initPageProperty = function() {
      initPageProperySlider()
      initLightbox()
    }
  
    $('.btn-menu--toggle').on('click', function () {
      var $body = $('body')
      var open = !$body.hasClass('menu-open')

      $body.toggleClass('menu-open')
      if (open) {
        $body.css('overflow', 'hidden')
      } else {
        $body.css('overflow', 'unset')
      }
    })
  
    $('.modal').on('show.bs.modal', function (e) {
      $.scrollify.disable()
    })
    $('.modal').on('hide.bs.modal', function (e) {
      $.scrollify.enable()
    })
  
    initPageProperty()

    var adminBarHeight = $('#wpadminbar').height()
    var headerHeight = $('#header').height()
    var controller = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: 0.9,
        // duration: '100%',
        offset: adminBarHeight * -1,
      }
    });
    $('.scroll-animate').each(function () {
      $(this).addClass('animate__animated')

      var animation = $(this).data('animation')

      var triggerElement
      
      if ($(this).data('scroll-animate-trigger') && $($(this).data('scroll-animate-trigger')).length) {
        triggerElement = $($(this).data('scroll-animate-trigger'))[0]
      }
      // else if ($(this).closest('section').length) {
      //   triggerElement = $(this).closest('section')[0]
      // } 
      else {
        triggerElement = this
      }

      new ScrollMagic.Scene({
        triggerElement,
      })
      .setClassToggle(this, 'animate__' + animation)
      // .setClassToggle(this, 'animated')
      // .addIndicators()
      .addTo(controller);
    });

    $('.btn-bgm').on('click', function () {
      var bgm = document.getElementById('bg_music')
      if (bgm.paused) {
        bgm.play()
      } else {
        bgm.pause()
      }
    })
  })
} )();
